import React from 'react';
import { Badge } from 'app/graphql/__generated__/types/contento';
import { PlayBadgeSize } from 'app/ui-components/PlayBadge/PlayBadge';
import { StyledBadge } from './LiveBadge.styles';

type Props = {
    badge: Badge;
    size: PlayBadgeSize;
};

const LiveBadge = ({ badge, size }: Props): JSX.Element => (
    <StyledBadge text={badge.text} theme={badge.type} accessibilityText={badge.altText} overlay size={size} />
);

export default LiveBadge;
